const END_CUSTOMER_ENTITY_KEY = 'endusers'
const ENDUSER_LIST_ENTITY_KEY = 'endcustomerendusers'

export default {
  data () {
    return {
      _endUserSectionsLoading: false
    }
  },
  computed: {
    endCustomerId () {
      return (this.eParent || {}).id
    },
    tenants () {
      return this.$store.getters['tenants/getUnwrapped'] || []
    },
    tenantById () {
      const map = {}
      this.tenants.forEach(t => {
        map[t.id] = t
      })
      return map
    },
    endUserIdsForEndCustomer () {
      if (!this.endCustomerId) return []
      return this.$store.getters[`${ENDUSER_LIST_ENTITY_KEY}/getByEndCustomerId`](this.endCustomerId) || []
    },
    endUsersForEndCustomer () {
      return this.endUserIdsForEndCustomer
        .map(id => this.$store.getters[`${ENDUSER_LIST_ENTITY_KEY}/getEntityUnwrapped`](id))
        .filter(Boolean)
    },
    endUserSections () {
      return this.endUsersForEndCustomer.map(eu => {
        const tenantId = eu.tenantId || eu.TenantId
        const tenant = tenantId ? this.tenantById[tenantId] : null

        return {
          endUserId: eu.id,
          tenantId,
          tenantName: tenant ? tenant.name : (tenantId ? `Unknown (${tenantId})` : 'Unknown'),
          endUser: eu
        }
      })
    },
    endCustomerHeaderEntityKey () {
      return END_CUSTOMER_ENTITY_KEY
    }
  },
  methods: {
    async ensureTenantsLoaded () {
      // tenants/getAll already exists and is used in EndUsers/Tenants.vue
      await this.$store.dispatch('tenants/getAll')
    },
    async loadEndUserSections () {
        if (!this.endCustomerId) return

        this._endUserSectionsLoading = true
        try {
          await Promise.all([
              this.ensureTenantsLoaded(),
              this.$store.dispatch(`${ENDUSER_LIST_ENTITY_KEY}/getByEndCustomerId`, this.endCustomerId)
            ])
        } finally {
          this._endUserSectionsLoading = false
      }
    }
  },
  created () {
    this.loadEndUserSections()
  },
  watch: {
    endCustomerId (next, prev) {
      if (next && next !== prev) this.loadEndUserSections()
    }
  }
}

